import { useEffect, useState } from "react"
import FormError from "../../riutilizabili/FormError"
import InputForm from "../../riutilizabili/forms/InputForm"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"


export default function CodiciForms2({
    item ,
    onChange ,
    prods =[] ,
    errors = {},
    codici = {} , 
    deleteCodice ,
    prodSeriali,
    onDelete
}){
    //console.log(prodSeriali ,' prodSeriali finale');
    
    return(
        
        <div className="d-flex flex-wrap align-items-center col-12">
            <div className="col-12 d-flex flex-wrap align-items-center mt-5">
                <p className="p-0 m-0 col-4 text-center">
                    Seriali :
                </p>
                <p className="p-0 m-0 col-4 text-center">
                    Provisioning :
                </p>
                
            </div>
            <div className="col-12 py-3">
                {
                    Array.from({length:item.quantita}).map((el , key) => {
                        const valueSeriale =prodSeriali[key] ? (prodSeriali[key].seriale || '') : ''
                        const valueProvisioning =prodSeriali[key] ? (prodSeriali[key].provisioning || '') : ''
                        //console.log(key , ' principale key onDelete');
                        
                        return (
                            <div key={key} className="d-flex flex-wrap align-items-center col-12">
                                <div className="col-4 d-flex flex-wrap align-items-center">
                                    <InputForm
                                        name={'seriali'}
                                        type='text'
                                        label={' '}
                                        value={valueSeriale}
                                        onChange={(nome , valore)=>onChange(key,'seriale',valore)}
                                        classi=" col-12 m-0 p-0 d-flex "
                                        errors={{}}
                                    />
                                </div>
                                <div className="col-4 d-flex flex-wrap align-items-center">
                                    <InputForm
                                        name={'provisioning'}
                                        type='text'
                                        label={' '}
                                        value={valueProvisioning}
                                        onChange={(nome , valore)=>onChange(key,'provisioning',valore)}
                                        classi=" col-12 m-0 p-0 d-flex "
                                        errors={{}}
                                    />
                                </div>
                                {(valueSeriale || valueProvisioning) && <button className="btn fs-3 text-danger" onClick={()=>onDelete(key)}>
                                    <FontAwesomeIcon icon={faXmark} />
                                </button>}
                            </div>
                        )
                    }
                    )
                }
            </div>
        </div>

    )

}